<h1 class="page-title w-50">الخدمات</h1>
<div class="container-fluid ">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="faq-container py-5">
    <h2> تقارير الاستثمار الأجنبى المباشر </h2>
    <div class="faq-item" *ngFor="let item of items">
      <div class="faq-header" (click)="toggle(item)">
        <div class="indicator" [class.expanded]="item.expanded">
          <i class="fa-solid" [class.fa-minus]="item.expanded" [class.fa-plus]="!item.expanded"></i>
        </div>
        <div class="title">{{ item.title }}</div>
      </div>
      <div class="faq-content" *ngIf="item.expanded">
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</div>